import {
  OnNewVersion,
  OnVersionChanged,
  OnVersionFetchError
} from './version.types'

export const VERSION_CHANGED = 'VERSION_CHANGED'
export const NEW_VERSION = 'NEW_VERSION'
export const FETCH_VERSION_ERROR = 'FETCH_VERSION_ERROR'

export const onVersionChanged: OnVersionChanged = () => ({
  type: VERSION_CHANGED
})

export const onNewVersion: OnNewVersion = version => ({
  payload: { version },
  type: NEW_VERSION
})

export const onVersionFetchError: OnVersionFetchError = error => ({
  payload: { error },
  type: FETCH_VERSION_ERROR
})
